import { z } from "zod";
import { tripAlertSchema } from "../../hooks/react-query/linehaul/useTripsDashboardAlerts";

// Use z.input to get the input type (before transformation) which has Date, not Dayjs
type TripAlertInput = z.input<typeof tripAlertSchema>;

export const mockTripAlerts = {
  default: [
    {
      id: 20,
      tripNumber: 294059,
      message: "grows their ETA more than 2 hours",
      notificationType: "EtaGrows",
      originSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 111,
        code: "ONT",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      stops: [],
      timestamp: new Date("2026-02-02T06:00:00Z"),
      actionType: "SeeMore",
      isRead: false,
    },
    {
      id: 18,
      tripNumber: 294057,
      message: "with UC/CC is falling into possible failure bucket",
      notificationType: "UcCcFailureBucket",
      originSic: {
        id: 115,
        code: "HTX",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      stops: ["EWR"],
      timestamp: new Date("2026-02-01T18:10:00Z"),
      actionType: "ContactCarrier",
      isRead: false,
    },
    {
      id: 17,
      tripNumber: 294056,
      message: "grows their ETA more than 2 hours",
      notificationType: "EtaGrows",
      originSic: {
        id: 111,
        code: "ONT",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 3,
        code: "SFO",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      stops: ["DAL"],
      timestamp: new Date("2026-02-01T16:45:00Z"),
      actionType: "SeeMore",
      isRead: false,
    },
    {
      id: 14,
      tripNumber: 294053,
      message: "with UC/CC is falling into possible failure bucket",
      notificationType: "UcCcFailureBucket",
      originSic: {
        id: 3,
        code: "SFO",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 111,
        code: "ONT",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      stops: ["DAL"],
      timestamp: new Date("2026-02-01T12:20:00Z"),
      actionType: "ContactCarrier",
      isRead: false,
    },
    {
      id: 13,
      tripNumber: 294052,
      message: "grows their ETA more than 2 hours",
      notificationType: "EtaGrows",
      originSic: {
        id: 115,
        code: "HTX",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: ["ONT"],
      timestamp: new Date("2026-02-01T10:15:00Z"),
      actionType: "SeeMore",
      isRead: false,
    },
    {
      id: 12,
      tripNumber: 294051,
      message: "is in mechanical status to allow for follow up",
      notificationType: "MechanicalStatus",
      originSic: {
        id: 111,
        code: "ONT",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      stops: [],
      timestamp: new Date("2026-02-01T10:05:00Z"),
      actionType: "SeeMore",
      isRead: false,
    },
    {
      id: 11,
      tripNumber: 294050,
      message: "tracks in the same area for more than 2 hours",
      notificationType: "TracksInSameArea",
      originSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 3,
        code: "SFO",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      stops: ["DAL", "ONT"],
      timestamp: new Date("2026-02-01T08:45:00Z"),
      actionType: "ContactCarrier",
      isRead: false,
    },
    {
      id: 2,
      tripNumber: 294040,
      message: "is in mechanical status to allow for follow up",
      notificationType: "MechanicalStatus",
      originSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 3,
        code: "SFO",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      stops: [],
      timestamp: new Date("2026-02-01T08:15:00Z"),
      actionType: "SeeMore",
      isRead: false,
    },
    {
      id: 1,
      tripNumber: 294039,
      message: "tracks in the same area for more than 2 hours",
      notificationType: "TracksInSameArea",
      originSic: {
        id: 111,
        code: "ONT",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: ["CHT"],
      timestamp: new Date("2026-02-01T06:00:00Z"),
      actionType: "ContactCarrier",
      isRead: false,
    },
    {
      id: 19,
      tripNumber: 294058,
      message: "tracks in the same area for more than 2 hours",
      notificationType: "TracksInSameArea",
      originSic: {
        id: 3,
        code: "SFO",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: ["ONT", "HTX"],
      timestamp: new Date("2026-01-30T18:10:00Z"),
      actionType: "ContactCarrier",
      isRead: true,
    },
    {
      id: 16,
      tripNumber: 294055,
      message: "is in mechanical status to allow for follow up",
      notificationType: "MechanicalStatus",
      originSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 155,
        code: "TEB",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: [],
      timestamp: new Date("2026-01-30T15:30:00Z"),
      actionType: "SeeMore",
      isRead: true,
    },
    {
      id: 15,
      tripNumber: 294054,
      message: "tracks in the same area for more than 2 hours",
      notificationType: "TracksInSameArea",
      originSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 1,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 115,
        code: "HTX",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      stops: ["EWR", "ONT"],
      timestamp: new Date("2026-01-30T14:00:00Z"),
      actionType: "ContactCarrier",
      isRead: true,
    },
    {
      id: 10,
      tripNumber: 294048,
      message: "with UC/CC is falling into possible failure bucket",
      notificationType: "UcCcFailureBucket",
      originSic: {
        id: 114,
        code: "DAL",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 115,
        code: "HTX",
        lhRegionId: 3,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      stops: ["EWR"],
      timestamp: new Date("2026-01-30T11:45:00Z"),
      actionType: "ContactCarrier",
      isRead: true,
    },
    {
      id: 9,
      tripNumber: 294047,
      message:
        "ETA falls within their closed hour (Non 24 hours drop destination)",
      notificationType: "EtaGrows",
      originSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 155,
        code: "TEB",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: [],
      timestamp: new Date("2026-01-30T08:15:00Z"),
      actionType: "SeeMore",
      isRead: true,
    },
    {
      id: 6,
      tripNumber: 294044,
      message: "grows their ETA more than 2 hours",
      notificationType: "EtaGrows",
      originSic: {
        id: 115,
        code: "HTX",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 1,
        code: "EWR",
        lhRegionId: 2,
        ownership: "C",
        timeZone: "America/New_York",
      },
      stops: ["ONT"],
      timestamp: new Date("2026-01-30T06:00:00Z"),
      actionType: "SeeMore",
      isRead: true,
    },
  ],
} as const satisfies Record<string, TripAlertInput[]>;
